export const ObstacleName = {
  ObstacleBananaSkin: 'obstacleBananaSkin',
  ObstacleBoxes: 'obstacleBoxes',
  ObstacleOilSlick: 'obstacleOilSlick',
  ObstacleWetConcrete: 'obstacleWetConcrete',
  ObstacleIcePatch: 'obstacleIcePatch',
  ObstacleLeafPile: 'obstacleLeafPile',
  ObstacleMudPatch: 'obstacleMudPatch',
  ObstacleSnowDrift: 'obstacleSnowDrift'
} as const;
export type ObstacleNameKeys = keyof typeof ObstacleName;
export type ObstacleNameValues = typeof ObstacleName[ObstacleNameKeys];

/* START OF COMPILED CODE */

import LaneEntityImage from "../LaneEntityImage";
/* START-USER-IMPORTS */
import { HitEffectValues } from '../../LaneEntityImageBase';
/* END-USER-IMPORTS */

export default class Obstacle extends LaneEntityImage {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 45, y ?? 45, texture || "common", frame ?? "icon-taxi-jerry.png");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */

    // custom definition props
    this.hitEffect = "none";
  }

  public slowStrength: number = 0;

  /* START-USER-CODE */
  public hitEffect: HitEffectValues;

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
